import { config } from "oems/config";

export function OEM() {
    return {
        ProductName: process.env.REACT_APP_PRODUCT_NAME,
        ProductTitle: process.env.REACT_APP_PRODUCT_TITLE,
        Copyright: process.env.REACT_APP_COPYRIGHT,
        ContactUrl: process.env.REACT_APP_CONTACT_URL,
        isInventoryEnabled: config.warehouse.childKeys.includes("products"),
    }
}